import { Alert, Button, Card, Col, Dropdown, Form, Input, Row, Select, Switch, Table, notification } from "antd"
// import { useClients } from "../../../System/Global/DataHooks/useClients";
import { useEffect, useState } from "react";
import AddressSection from "./Components/AddressSection";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { FiArrowRight, FiMenu, FiRefreshCcw } from "react-icons/fi";
// import Running from "../../../System/Components/Running";
import dayjs from 'dayjs'
import { get, save, sendConfirmation } from "../../System/Api/API";
// import Loader from '../../../System/Components/Loader'
// import { AlertFilled } from "@ant-design/icons";
// import { useGlobal } from "../../../System/Global/GlobalProvider";
// import { parseStringifiedArrays, unescapeNested } from "../../../System/Global/unescapeArray";
import generateMiles from "./Quote/generateMiles";
import generatePrices from "./Quote/generatePrices";
import MapSection from "./Quote/MapSection";
import Running from "../../System/Components/Running";
import { useGlobal } from "../../System/Global/GlobalProvider";
import { escapeNested, stringifyArraysInObject } from "../../System/Global/unescapeArray";
import Loader from "../../System/Components/Loader";
export const BookingNew = () => {

    const [ form ] = Form.useForm()
    const { UserData } = useGlobal()
    const [ client, setClient ] = useState()
    const [ collections, setCollections ] = useState([])
    const [ deliveries, setDeliveries ] = useState([])
    const { bookingKey } = useParams();
    const [ screen, setScreen ] = useState("details")
    const [isRoundTrip, setIsRoundTrip] = useState(false); 
    const [ booking, setBooking ] = useState();
    const [ isLoading, setIsLoading ] = useState(false)
    const [ templates, setTemplates ] = useState([])
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [ typeCode, setTypeCode ] = useState() // used for avonmouth site type 3
    const [ mileage, setMileage ] = useState()
    const [ price, setPrice ] = useState()
    const navigate = useNavigate()

    const initialValues = {
        vatCode: "1",
        typeCode: "1",
        canType: "Small Van",
        ignorePod: 0,
        customsBooking: 0,

    }

    useEffect( () => {

        ( async () => {

            const _client = await get('clients', {clientKey: UserData.clientKey})
            console.log(_client)
            setClient(_client[0])
        })()
        

    },[])

    const startMiles = async () => {

        setScreen("map")

    }

    const updatePricing = (price) => {

        let typeCode = "1"

        if (+price.maxWeight < 3000) {
            typeCode = "2"
        } 

        form.setFieldsValue({
            typeCode: typeCode,
            vanType: price.name,
            basePrice: price.price,
        })

        setTypeCode(typeCode)
        setPrice(price)

    }
    
    const convertAddress = (addresses, prefix) => {

        let address = {
            [`${prefix}_name`]:   addresses[0].name,
            [`${prefix}_addressLine1`]:   addresses[0].addressLine1,
            [`${prefix}_addressLine2`]:   addresses[0].addressLine2,
            [`${prefix}_addressLine3`]:   addresses[0].addressLine3,
            [`${prefix}_townName`]:   addresses[0].townName,
            [`${prefix}_postCode`]:   addresses[0].postCode,
            [`${prefix}_country`]:   addresses[0].country,
            [`${prefix}_date`]:   dayjs(addresses[0].date).format('YYYY-MM-DD'),
            [`${prefix}_time`]:   addresses[0].timeType === "ASAP" ? "ASAP" : dayjs(addresses[0].time).format("HH:mm"),
            [`${prefix}_instructions`]:   addresses[0].instructions,
            [`${prefix}_reference`]:   addresses[0].reference,
        }

        let additionalAddresses = [];

        let items = [...addresses].slice(1);

        items.forEach(item => additionalAddresses.push({
            [`${prefix}_name`]:         item.name,
            [`${prefix}_addressLine1`]: item.addressLine1,
            [`${prefix}_addressLine2`]: item.addressLine2,
            [`${prefix}_addressLine3`]: item.addressLine3,
            [`${prefix}_townName`]:     item.townName,
            [`${prefix}_postCode`]:     item.postCode,
            [`${prefix}_country`]:      item.country,
            [`${prefix}_date`]:         dayjs(item.date).format('YYYY-MM-DD'),
            [`${prefix}_time`]:         item.timeType === "ASAP" ? "ASAP" : dayjs(item.time).format("HH:mm"),
            [`${prefix}_time_type`]:    item.timeType === "ASAP" ? "ASAP" : "Timed",
            [`${prefix}_instructions`]: item.instructions,
            [`${prefix}_reference`]:    item.reference,
        }))

        return [address, additionalAddresses];

    }

    
    const priceCard = () => {

        return (
            <Card>
                <div style={{border: '1px solid #F1F2F5', padding: 20, margin: 10}}>

                { price &&
                
                <Row gutter={16} display="flex" align={"middle"}>
                    <Col xs={10}>
                        <Form.Item label="Price" name="basePrice" rules={[
                            {
                                required: true,
                                message: 'Please enter a price!',
                            }]}>
                            <Input type="number"/>
                        </Form.Item>
                    </Col>
                    
                    
                    <Col xs={14}>
                        { typeCode !== "3" &&
                        <Form.Item label={"Vehicle Type"} name="vanType">
                                <Input disabled />
                        </Form.Item> }
                    </Col>
                    
                    <Col xs={24}>
                        <Button style={{marginTop: 20, width: '100%'}} onClick={() => startMiles()}>Change Vehicle</Button>
                    </Col>
                </Row> }
                </div>
            </Card>
        )
    }
    const detailsCard = () => {

        return (
            
            <Card>

                <div style={{border: '1px solid #F1F2F5', padding: 20, margin: 10}}>
                
                <Row gutter={16} display="flex" align={"middle"}>
                    
                    <Col xs={12}>
                        <Form.Item label="Order No" name="orderNo" rules={[
                            {
                                required: true,
                                message: 'Please enter an order number!',
                            }]}>
                            <Input/>
                        </Form.Item>
                        
                    </Col>
                    <Col xs={12}>
                        <Form.Item label="Your Ref (optional)" name="customerRef">
                            <Input/>
                        </Form.Item>
                    </Col>
                </Row>

                </div>
                
            </Card> 
        )
    }

    const saveBooking = async (newItems) => {

        newItems = await escapeNested(newItems);
        newItems = await stringifyArraysInObject(newItems)

        if (newItems.col_time) {
            newItems.col_time = unescape(newItems.col_time)
        }
        if (newItems.del_time) {
            newItems.del_time = unescape(newItems.del_time)
        }

        
    
        const bookingKey = await save('bookings_draft', newItems)

        return bookingKey;

    }
    
    const submitBooking = async (values) => {

        setIsLoading(true)

        const [ col, cols ] = convertAddress(collections, 'col')
        const [ del, dels ] = convertAddress(deliveries, 'del')

        console.log('values', values)

        

        let bookingItem = {
            ...values,
            roundTrip:      isRoundTrip ? '1' : '0',
            ...col,
            collections:    cols,
            ...del,
            deliveries:     dels,
            ignorePod:      `1`,

        }

        if (dayjs(col.col_date).isAfter(dayjs(del.del_date))) {

            notification.error({
                message: "Error",
                description: "The delivery date is before the collection date",
                duration: 1,
            })

            return
        }

        // client.invoice_vat
        // typeCode

        const vc = (() => {
            switch (client.invoice_vat) {
                case "T1":
                    return "1";
                case "T0":
                    return "9";
                case "T9":
                    return "2";
                case "T15":
                    return "3";
                case "T2":
                    return "4";
                default:
                    return "0";
            }
        })();

        const data = {
            ...bookingItem, 
            vatCode:        vc,
            clientKey:      client.clientKey,
            userKey:        UserData.userKey,
            extraCharges:   [],
            mileage:        `${mileage.miles}`,
            totalPrice:     +bookingItem.basePrice,
            status:         "Draft",
            invoiced:       '0',
            orderNo:        bookingItem.orderNo,
        }

        let bk = await saveBooking(data)

        // generate confirmation email
        await sendConfirmation('book@opex.co.uk', client.name, col.col_name + ' ' + col.col_townName, del.del_name + ' ' + del.del_townName)

        navigate(`/bookings/draft/view/${bk}`)

        setIsLoading(false)

    }
    
    return (
        isLoading ?  
        <Row gutter={16}>
        <Col xs={24}>
            <Loader />
        </Col></Row> :
        <div style={{padding: 20}}>
        <Row gutter={16}>
            <Col xs={24}>
            <Form onFinish={submitBooking} form={form} layout="vertical" initialValues={initialValues}>
            <div style={{display: 'flex', alignItems: "center"}}>
                <div style={{flex: 1}}>
                    <h1 style={{marginTop: 0}}>{ "New Booking" }</h1>
                </div>
                <div>
                    {/* { collections.length > 0 && deliveries.length > 0 && !price && <Button type={"success"} onClick={startMiles}>Generate prices</Button> } */}
                    { screen === "details" &&
                        <>
                            
                            <Switch checked={isRoundTrip} style={{marginRight: 20}} checkedChildren="Round Trip" unCheckedChildren="One-way" onChange={(checked) => setIsRoundTrip(checked)} />
                            {/* <Button type="primary" htmlType="submit">Save booking</Button>  */}
                        </>
                    }
                </div>
            </div>

            { true && 

            <div>
                { screen === "details" ?
    
                <>
                
                <Row gutter={10}>
                    
                    <Col span={12}>
                        <AddressSection addresses={collections} setAddresses={setCollections} client={client} type="Collection"/>
                    </Col>
                    <Col span={12}>
                        <AddressSection addresses={deliveries} setAddresses={setDeliveries} client={client} type="Delivery"/>
                    </Col>
                    <Col span={24}>
                        { collections?.length > 0 && deliveries?.length > 0 &&
                        <ItemsSection/> }
                    </Col>
                </Row>
                
                <Row gutter={10}>
                    <Col xs={12}>
                    
                        {  collections?.length > 0 && deliveries?.length > 0 && price && priceCard() }
                    </Col>
                    <Col xs={12}>
                        { collections?.length > 0 && deliveries?.length > 0 && price && detailsCard() }
                    </Col>
                </Row>

                { collections?.length > 0 && deliveries?.length > 0 && !price &&
                <div style={{textAlign: 'right'}}>
                    <Button style={{width: '100%'}} type="primary" onClick={() => startMiles()}>Choose Vehicle</Button>
                </div>}

                { collections?.length > 0 && deliveries?.length > 0 && price &&
                <div style={{textAlign: 'right'}}>
                    <Button style={{width: '100%'}} type="primary" htmlType="submit">Submit Booking</Button>
                </div>}
                
                </>
                    :
                    <Row gutter={10}>
                        <Col xs={24}>
                            <PricingSection roundTrip={isRoundTrip ? 1 : 0} setMileage={setMileage} client={client} updatePricing={updatePricing} setScreen={setScreen} collections={collections} deliveries={deliveries}/>
                        </Col>
                    </Row>
                    }
            </div> 
            }
            </Form>
            </Col>
        </Row>
        </div>
    )
}

const PricingSection = ({updatePricing, setScreen, client, collections, deliveries, setMileage, roundTrip}) => {

    const [ calculating, setCalculating] = useState(true)
    const [ prices, setPrices ] = useState();
    const [ directions, setDirections ] = useState(null)
    const [ vehicleTypes, setVehicleTypes ] = useState([])

    useEffect( () => {

        ( async () => {

            const _vehicles = await get('vehicle_types', null, [{fieldName: 'maxWeight', orderDirection: 'ASC'}])
            setVehicleTypes(_vehicles)

            console.log('client', client)
        })()
        

    },[])

    useEffect( () => {
        
        if (vehicleTypes?.length > 0) {

            start()
            
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[vehicleTypes])

    const start = async () => {

        console.log(collections, deliveries, client)

        let _mileage = await generateMiles(collections, deliveries)
        let _prices = await generatePrices(collections, deliveries, _mileage.miles, roundTrip, _mileage.start, _mileage.end, client.clientKey);
        

        setMileage(_mileage)
        
        if (_mileage.directions) {
            setDirections(_mileage.directions)
        }

        conditionPrices(_prices)

        setCalculating(false)
    }

    const conditionPrices = (_prices) => {

        let priceTable = [];
    
        vehicleTypes.forEach((v) => {
            let systemSetRouteRate = _prices.systemSetRouteRates.find(p => p.vtKey === v.vtKey && p.price > 0);
            let clientSetRouteRate = _prices.clientSetRouteRates.find(p => p.vtKey === v.vtKey && p.price > 0);
            let mileageRate = _prices.mileagePrices.find(p => p.vtKey === v.vtKey && p.price > 0);
    
            let lowest = Math.min(
                systemSetRouteRate ? +systemSetRouteRate.price : Number.MAX_VALUE,
                clientSetRouteRate ? +clientSetRouteRate.price : Number.MAX_VALUE,
                mileageRate ? +mileageRate.price : Number.MAX_VALUE
            );
    
            // If no valid prices found, set lowest to a default or null
            if (lowest === Number.MAX_VALUE) {
                lowest = 0; // or null, depending on how you want to handle this case
            }
    
            priceTable.push({
                vtKey:  v.vtKey,
                price: parseFloat(lowest).toFixed(2).toLocaleString(),
                name:   v.name,
                maxWeight: v.maxWeight,
                size: v.size,
                typeCode: v.typeCode,
            });
        });
    
        setPrices(priceTable);
    }

    const onRowClick = (record) => {
        return {
            onClick: event => {

                updatePricing(record)
                setScreen("details")
            },
        };
    };

    return (
        calculating ? 
        <Row gutter={16}>
            <Col span={24}>
                <div style={{textAlign: 'center', marginTop: 100}}>
                    <Running/>
                </div>
            </Col> 
        </Row>
                :
        <Row gutter={16}>
            
            <Col span={12}>
                <MapSection directions={directions}/> 
            </Col>
            <Col xs={12}>
                
                <Table 
                    rowKey={"vtKey"}
                    dataSource={prices}
                    pagination={false}
                    onRow={onRowClick}
                    columns={[
                        {
                            title: 'Vehicle.',
                            dataIndex: 'name',
                            key: 'name',
                        },
                        {
                            title: 'Size.',
                            dataIndex: 'size',
                            key: 'size',
                        },
                        {
                            title: 'Weight.',
                            dataIndex: 'maxWeight',
                            key: 'maxWeight',
                        },
                        {
                            title: 'Price',
                            render: item => <div style={{textAlign: 'right', paddingRight: 10, fontWeight: 'bold', fontSize: 16}}>£{item.price}</div>,
                            key: 'price',
                        },
                    ]}
                />
                
                <Button onClick={() => setScreen("details")}>Cancel</Button>
            </Col>
        </Row>
    )
}



const inputStyle = {
    // height: 30,
    // fontSize: 12
}
const formItemStyle = {
    marginBottom: 5,
    // minHeight: 30,
    
}

const ItemsSection = () => {

    return (
        <Card style={{margin: 10}}>
            <div style={{padding: 20, border: '1px solid #F1F2F5'}}>
            
                <Row gutter={16}>
                    <Col span={4}>
                        <Form.Item name="itemCount" label="Qty" style={formItemStyle} className="small" rules={[
                            {
                                required: true,
                                message: 'Please enter the qty!',
                            }]}>
                            <Input type="number" style={inputStyle} />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name="itemType" label="Type"  style={formItemStyle} rules={[
                            {
                                required: true,
                                message: 'Please enter the items type!',
                            }]}>
                        <Input style={inputStyle} />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name="itemKgs" label="Kgs"  style={formItemStyle} rules={[
                            {
                                required: true,
                                message: 'Please enter the weight!',
                            }]}>
                        <Input type="number" style={inputStyle} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="itemText" label="Description"  style={formItemStyle}>
                        <Input style={inputStyle} />
                        </Form.Item>
                    </Col>
                </Row>
            
            </div>
        </Card>
    )
}


const ClientSearch = ({ setClient }) => {

    // const { searchClients } = useClients();
    const [ filteredClients, setFilteredClients ] = useState()
    const [ search, setSearch ] = useState("")
    // const { fetchTemplates } = useBookings();

    const startSearch = async (e) => {

        e.preventDefault();

        let _clients = []// await searchClients(search, "User", "all")

        for await (let c of _clients) {

            let templates = [] //await fetchTemplates(c.clientKey)
            c.templates = templates;
        }

        if (_clients.length === 1) {

            setClient(_clients[0])
        } else {
            setFilteredClients(_clients)
        }
        
    }

    const onRowClick = (record) => {
        return {
            onClick: event => {
                setClient(record)
            },
        };
    };

    

    const columns = [
        {
            title: 'Reference',
            render: item => `${item.reference}`,
            key: 'reference',
        },
        {
            title: 'Client',
            render: item => `${item.name}`,
            key: 'driver',
        },
        {
            title: 'Address',
            render: item => `${item.ad1} ${item.town} ${item.pcode}`,
            key: 'address',
        },
        {
            title: 'Phone',
            render: item => `${item.phone || ""}`,
            key: 'phone',
        },
        {
            title: 'Email',
            render: item => `${item.email || ""}`,
            key: 'email',
        },
        {
            title: 'Status',
            render: item => <div style={{
                width: 100,
                textAlign: "center",
                padding: '5px 10px',
                backgroundColor: item.status === "Stop" ? "#FF4D4F" : item.status === "Inactive" ? "#e6ac00" : "inherit",
                color: item.status !== "Live" ? "#fff" : "inherit",
            }}>
                {item.status}
            </div>,
            key: 'status',
        },
        
    ];

    
    
    return (
        <>
        <div style={{marginBottom: 30}}>
            <Card>
                <Input autoFocus onPressEnter={startSearch} value={search} onChange={(e) => setSearch(e.target.value)} style={{width: '100%'}} placeholder={"Search by client name..."}/>
            </Card>
        </div>
        { filteredClients && 
            <Table 
                
                // defaultExpandedRowKeys={filteredClients.map(row => row.templates.length > 0 && row.clientKey)}
                // expandable={{
                //     expandedRowRender,
                //     rowExpandable: record => record.templates.length > 0, // 'expandable' is a field in your data
                // }}
                pagination={false} 
                rowKey="clientKey" 
                columns={columns} 
                dataSource={filteredClients} 
                onRow={onRowClick} 
            /> 
        }
        </>
    )

}
